import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderComponent } from './components/slider/slider.component';
import { SliderItemComponent } from './components/slider-item/slider-item.component';
import { LibDirectivesModule } from '@utils/directives/lib-directives.module';
import { MatIconModule } from '@angular/material/icon';
import { SliderItemMoreComponent } from './components/slider-item-more/slider-item-more.component';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [SliderComponent, SliderItemComponent, SliderItemMoreComponent],
  imports: [CommonModule, LibDirectivesModule, MatIconModule, RouterModule],
  exports: [SliderComponent, SliderItemComponent],
})
export class LibSliderModule {}
